import appointmentDoc from "@/assets/lm/appointment-setting-doc-cover-v2.png.asset.json";
import postingDoc from "@/assets/lm/posting-doc-cover-v2.png.asset.json";

/** Every free resource shown on /resources. To add one, add one entry here. */
export type Resource = {
  type: "PLAYBOOK" | "GUIDE" | "AI TOOL";
  title: string;
  description: string;
  href: string;
  /** Main document picture from its page; omit for tools without a document (a branded tile is shown). */
  image?: string;
  imageAlt?: string;
};

export const resources: Resource[] = [
  {
    type: "PLAYBOOK",
    title: "The Homeowner Appointment-Setting Playbook",
    description: "The exact system behind 4,500+ booked homeowner appointments: what to do before, during and after the call.",
    href: "/lm/appointment-setting",
    image: appointmentDoc.url,
    imageAlt: "The Homeowner Appointment-Setting Playbook in Google Docs",
  },
  {
    type: "GUIDE",
    title: "Where to Post as a Remodeling Company (and How to Be Everywhere in No Time)",
    description: "Which platforms to post on, what to film and how to show up everywhere your homeowners scroll, without a full-time content team.",
    href: "/lm/posting",
    image: postingDoc.url,
    imageAlt: "Where to Post as a Remodeling Company guide in Google Docs",
  },
  {
    type: "AI TOOL",
    title: "AI Appointment-Setting Script Builder",
    description: "Answer 5 quick questions and get a phone script built for your business that your setter can use today.",
    href: "/lm/script-builder",
  },
  {
    type: "GUIDE",
    title: "The Bottom-of-Funnel Ad that Prints Every Time",
    description: "The 7-block video ad script, 20 winning hooks and the B-roll checklist to film it with your phone.",
    href: "/lm/video-ad",
  },
  {
    type: "AI TOOL",
    title: "AI Video Ad Script Writer",
    description: "Answer 6 questions and get your bottom-of-funnel ad script and 5 hooks, written for your business.",
    href: "/lm/ad-script-builder",
  },
];
